var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.3346H10M9.16667 5.21133C9.69937 5.07422 10.2578 5.0013 10.8333 5.0013C14.5152 5.0013 17.5 7.98607 17.5 11.668C17.5 14.4658 15.7765 16.8611 13.3333 17.85M4.58333 10.8346H7.91667C8.30388 10.8346 8.49749 10.8346 8.65848 10.8667C9.31964 10.9982 9.83646 11.515 9.96798 12.1762C10 12.3371 10 12.5308 10 12.918C10 13.3052 10 13.4988 9.96798 13.6598C9.83646 14.3209 9.31964 14.8378 8.65848 14.9693C8.49749 15.0013 8.30388 15.0013 7.91667 15.0013H4.58333C4.19612 15.0013 4.00251 15.0013 3.84152 14.9693C3.18037 14.8378 2.66354 14.3209 2.53202 13.6598C2.5 13.4988 2.5 13.3052 2.5 12.918C2.5 12.5308 2.5 12.3371 2.53202 12.1762C2.66354 11.515 3.18037 10.9982 3.84152 10.8667C4.00251 10.8346 4.19612 10.8346 4.58333 10.8346ZM3.33333 4.58464V10.8346H9.16667V4.58464C9.16667 2.9738 7.86083 1.66797 6.25 1.66797C4.63917 1.66797 3.33333 2.9738 3.33333 4.58464Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhance);
export default __webpack_public_path__ + "static/media/enhance.86d3cbdb07dc1f10caaa12a765b56bf8.svg";
export { ForwardRef as ReactComponent };